import { all_company, ExpiredTime } from "constants/configLocalStorage";
import moment from "moment";
import { useCallback } from "react"
import { useDispatch, useSelector } from "react-redux"
import API from "service/API"
import { setCompanyInfo, setCompanySame } from "store/actionReducers/CompanyStore";
import { setLoading } from "store/actionReducers/LoadingStore";

const useCompany = () => {
  const dispatch = useDispatch();
  const CompanyStore = useSelector((state: any) => state?.CompanyStore)

  const fetchAllCompany = useCallback(async () => {
    const res = await API.Company.FindAllCompany();
    if (res?.code === '0') {
      const time = moment().add(ExpiredTime, 'minutes').valueOf()
      localStorage.setItem(all_company, JSON.stringify({ time: time, data: res?.data }))
      dispatch(setCompanyInfo(res?.data))
    }
  }, [])

  const fetchCompanySame = useCallback(async (data: any) => {
    if (data?.stock) {
      dispatch(setLoading({ value: 'companySame' }))
      const res = await API.Company.FindCompanySame(data?.stock, { page: data?.page, size: data?.size });
      if (res?.code === '0') {
        if (res?.data?.data) {
          let listOld = [...CompanyStore?.companySame]
          listOld = listOld.concat(res?.data?.data)
          dispatch(setCompanySame(listOld))
        }
      }
      dispatch(setLoading({ value: 'companySame' }))
    }
  }, [CompanyStore?.companySame])

  return { fetchAllCompany, fetchCompanySame }
}

export default useCompany